/** Shared post-login landing path by role (password + SSO). */
export function postLoginPath(role) {
  if (role === "Employee") return "/my-devices";
  if (role === "Auditor") return "/assets";
  return "/dashboard";
}

export default postLoginPath;
